import { Skeleton } from '@/components/ui/skeleton';

export function WeaponsSkeleton() {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex min-h-6 items-center gap-1.5">
        <Skeleton className="size-3.5 rounded-sm" />
        <Skeleton className="h-3 w-16 rounded-md" />
        <Skeleton className="size-4 rounded-md" />
      </div>
      <div className="grid w-full gap-0.5">
        <ItemSkeleton />
        <ItemSkeleton />
      </div>
    </div>
  );
}

function ItemSkeleton() {
  return (
    <div className="flex items-center gap-2 px-1 py-0.5">
      <Skeleton className="size-4 shrink-0 rounded-sm opacity-50" />
      <Skeleton className="size-9 shrink-0 rounded-lg" />
      <Skeleton className="h-4 w-32 rounded-md" />
    </div>
  );
}
